import { useEffect, useRef, useState } from "react";
import { CURRENCY_LIST, ENTER_CURRENCY } from "../../currency";
import { Icon } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

const ShowBalance = () => {
  const memberData = useSelector((state) => state.isMemberInfo);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(
    ENTER_CURRENCY[0]?.text?.toLowerCase()
  );

  const location = useLocation();
  const navigate = useNavigate();

  const currencyInfo = ENTER_CURRENCY.find(
    (item) => item.value === selectedCurrency
  );

  const dropdownRef = useRef(null);

  const handleCurrencyChange = (value) => {
    setSelectedCurrency(value);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("currency", selectedCurrency);
    navigate(`?${params.toString()}`);
  }, [selectedCurrency]);

  return (
    <div>
      <div className="flex items-center inline-block">
        <div className="mr-2">選擇幣別</div>
        <div
          className="my-2 p-2 border border-gray-300 relative rounded-md cursor-pointer flex items-center"
          onClick={toggleDropdown}
        >
          <div className="flex items-center mr-2">
            {currencyInfo && (
              <img
                src={currencyInfo.icon}
                alt={currencyInfo.label}
                className="w-6 h-6 mr-2"
              />
            )}
            <span>
              {/* {
                ENTER_CURRENCY.find(
                  (option) => option.value === selectedCurrency
                )?.text
              } */}
              {selectedCurrency?.toUpperCase()}
            </span>
          </div>
          <Icon name={isOpen ? "caret up" : "caret down"} />
          {isOpen && (
            <div
              className="absolute mt-1 shadow-lg rounded-md py-1 z-10 !right-[0px] bg-second-color w-full !top-[40px]"
              ref={dropdownRef}
            >
              {ENTER_CURRENCY.map((option) => {
                return (
                  <div
                    key={option.value}
                    className={`cursor-pointer flex items-center p-2 hover:bg-gray-200 ${
                      option.value === selectedCurrency ? "font-semibold" : ""
                    }`}
                    onClick={() => handleCurrencyChange(option.value)}
                  >
                    <img
                      src={option.icon}
                      alt={option.label}
                      className="w-6 h-6 mr-2"
                    />
                    <span>{option.text}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowBalance;
